import { Route, Routes, Outlet } from 'react-router-dom';
import RouteScrollToTop from '../helper/RouteScrollToTop';
import HomePage from '../pages/home/HomePage';
import ProductPage from '../pages/product/ProductPage';
import SearchProductPage from '../pages/product/SearchProductPage';
import ProductDetailsPage from '../pages/product/ProductDetailsPage';
import CartPage from '../pages/account/CartPage';
import CheckoutPage from '../pages/account/CheckoutPage';
import FreeDeliveryPage from '../pages/free-delivery/FreeDeliveryPage';
import AccountPage from '../pages/account/AccountPage';
import ContactPage from '../pages/contact/ContactPage';
import PhosphorIconInit from '../helper/PhosphorIconInit';
import BecomeSellerPage from '../pages/become-seller/BecomeSellerPage';
import WishlistPage from '../pages/account/WishlistPage';
import LoginPage from '../pages/account/LoginPage';
import RegisterPage from '../pages/account/RegisterPage';
import PrivateRoute from '../components/auth/PrivateRoute';
import DynamicContentPage from '../pages/dynamic-content/DynamicContentPage';
import PaymentSuccessPage from '../pages/account/PaymentSuccessPage';
import SellerStorePage from '../pages/sellerstore/SellerStorePage';
import DirectSellerRegistrationPage from '../pages/seller-registration/FirstTimeRegistration';
import CustomerSellerRegistrationPage from '../pages/seller-registration/CustomerRegistration';
import CustomerSellerRegistrationPageStepOne from '../pages/seller-registration/StepOne';
import ShopInformation from '../pages/seller-registration/StepTwo';
import PaymentSummaryPage from '../pages/seller-registration/StepThree';
import SellerRegisCompletedPage from '../pages/seller-registration/RegistrationCompleted';

import { LogoutSeller } from '../pages/account/LogoutSeller';
import OrderDetailPage from '../pages/account/OrderDetailPage';

//admin
import AdminLoginPage from '../pages/webseller/loginseller';
import ForgotPassword from '../components/auth/ForgotPassword';
import ResetPassword from '../components/auth/ResetPassword';
import AdminProductList from '../pages/webseller/ProductsListPage';
import AdminSellerRegistration from '../pages/webseller/Registration';
import SellerTypeRegistration from '../pages/webseller/SellerType';
import SellerRegistrationDocVerify from '../pages/webseller/SellerDocumentVerificationCompany';
import SellerShopInformation from '../pages/webseller/SellerShopInformationCompany';
import SellerSubsPaymentSummaryPage from '../pages/webseller/SellerPaymentSummary';
import PersonalSellerRegistrationDocVerify from '../pages/webseller/SellerDocumentVerificationPersonal';
import PersonalSellerShopInformation from '../pages/webseller/SellerShopInformationPersonal';

import AdminSellerRegisCompletedPage from '../pages/webseller/RegistrationCompleted';

import { OnboardingProvider, OnboardingGuard } from '../context/OnboardingContext';
import { AdminRegistrationOnboardingProvider, AdminRegistrationOnboardingGuard } from '../context/AdminSellerRegistrationOB';

import { BusinessType } from '../components/seller-registration/adminregistration/SellerTypeForm';
import { GenderEnum, IDTypeEnum } from '../components/seller-registration/adminregistration/PersonalDocumentVerificationForm';


import TermsAndCondition from "../pages/terms-and-condition/TermsandCondition";
import PrivacyPolicy from "../pages/terms-and-condition/PrivacyPolicy";
import MembershipAgreement from '../pages/terms-and-condition/MembershipAgreement';


// const LanguageRouter = () => {
//   const { lang } = useParams();
//   const { isLoggedIn } = useJWT();

//   return (
//     <Routes>
//       {/* Public Routes */}
//       <Route element={<PublicLayout />}>
//         <Route path="login" element={<LoginPage lang={lang} />} />
//         <Route path="register" element={<RegisterPage lang={lang} />} />
//         <Route path="help" element={<HelpPage lang={lang} />} />
//       </Route>

//       {/* Protected Routes */}
//       <Route
//         element={
//           isAuthenticated ? <ProtectedLayout /> : <Navigate to={`/${lang}/login`} />
//         }
//       >
//         <Route path="dashboard" element={<Dashboard lang={lang} />} />
//         <Route path="settings" element={<Settings lang={lang} />} />
//       </Route>

//       {/* Catch-all */}
//       {/* <Route path="*" element={<NotFound />} /> */}
//     </Routes>
//   );
// };

{/* -- Use this APP ROUTER for iwant-asia.com --*/}
// const AppRouter = () => (
//     <>
//         <RouteScrollToTop />
//         <PhosphorIconInit />

//         <Routes>
//             <Route exact path="/" element={<CountryPage />} />
//         </Routes>
//     </>
// );

{/* -- Use This APP ROUTER for id.iwant-asia.com or sg.iwant-asia.com -- */}
const AppRouter = () => (
    <>
        <RouteScrollToTop />
        <PhosphorIconInit />

        <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/login" element={<LoginPage />} />
            <Route exact path="/logout-reseller" element={<LogoutSeller />} />
            <Route exact path="/register" element={<RegisterPage />} />
            <Route exact path="/products" element={<ProductPage />} />
            <Route exact path="/search" element={<SearchProductPage />} />
            <Route exact path="/product-details" element={<ProductDetailsPage />} />
            <Route exact path="/product-details/:slug" element={<ProductDetailsPage />} />
            <Route exact path="/free-delivery" element={<FreeDeliveryPage />} />
            <Route
                exact
                path="/cart"
                element={
                    <PrivateRoute>
                        <CartPage />
                    </PrivateRoute>
                }
            />
            <Route
                exact
                path="/payment/complete"
                element={
                    <PrivateRoute>
                        <PaymentSuccessPage />
                    </PrivateRoute>
                }
            />
            <Route
                exact
                path="/checkout"
                element={
                    <PrivateRoute>
                        <CheckoutPage />
                    </PrivateRoute>
                }
            />
            <Route exact path="/become-seller" element={<BecomeSellerPage />} />
            <Route exact path="/seller-store" element={<SellerStorePage />} />
            <Route exact path="/seller-register-blank" element={<DirectSellerRegistrationPage />} />
            <Route exact path="/seller-register" element={<CustomerSellerRegistrationPage />} />

            {/* Onboarding flow wrapper */}
            <Route
                element={
                    <OnboardingProvider>
                        <Outlet />
                    </OnboardingProvider>
                }
            >
                <Route path="/registration-document-verification" element={<CustomerSellerRegistrationPageStepOne />} />
                <Route
                    path="/registration-shop-information"
                    // element={<ShopInformation />}
                    element={
                        <OnboardingGuard
                            redirectTo="/registration-document-verification"
                            allowIf={({ data }) => !!data?.ownerName && !!data?.businessType && !!data?.citizenID}
                        >
                            <ShopInformation />
                        </OnboardingGuard>
                    }
                />
                <Route
                    path="/registration-shop-summary"
                    // element={<PaymentSummaryPage />}
                    element={
                        <OnboardingGuard
                            allowIf={({ data }) =>
                                !!data?.ownerName &&
                                !!data?.businessType &&
                                !!data?.citizenID &&
                                !!data?.email &&
                                !!data?.shopName &&
                                !!data?.phone
                            }
                            redirectTo="/registration-shop-information"
                        >
                            <PaymentSummaryPage />
                        </OnboardingGuard>
                    }
                />

                <Route
                    path="/registration-seller-completed"
                    // element={<SellerRegisCompletedPage />}
                    element={
                        <OnboardingGuard allowIf={({ qris }) => !!qris?.qrisImage} redirectTo="/registration-shop-information">
                            <SellerRegisCompletedPage />
                        </OnboardingGuard>
                    }
                />
            </Route>

            {/* After onboarding */}

            {/* <Route exact path="/registration-document-verification" element={<CustomerSellerRegistrationPageStepOne/>}/>
			<Route exact path="/registration-shop-information" element={<ShopInformation/>}/>
			<Route exact path="/registration-shop-summary" element={<PaymentSummaryPage/>}/>
			<Route exact path="/registration-seller-completed" element={<SellerRegisCompletedPage/>} /> */}

            <Route exact path="/wishlist" element={<WishlistPage />} />
            <Route exact path="/:type" element={<DynamicContentPage />} />
            <Route
                exact
                path="/account"
                element={
                    <PrivateRoute>
                        <AccountPage />
                    </PrivateRoute>
                }
            />
            <Route
                exact
                path="/order-detail"
                element={
                    <PrivateRoute>
                        <OrderDetailPage />
                    </PrivateRoute>
                }
            />
            <Route exact path="/contact" element={<ContactPage />} />

            {/* admin pages */}
            <Route exact path="/admin/products" element={<AdminProductList />} />
            <Route exact path="/admin/products/:slug" element={<AdminProductList />} />
            <Route exact path="/admin/register" element={<AdminSellerRegistration />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
                element={
                    <AdminRegistrationOnboardingProvider>
                        <Outlet />
                    </AdminRegistrationOnboardingProvider>
                }
            >
                {/* <Route exact path="/admin/register-seller-type" element={<SellerTypeRegistration />} /> */}
                <Route path="/admin/register-seller-type" element={<SellerTypeRegistration />} />

                {/* <Route exact path="/admin/document-verification-company"  
                    element={
                        <AdminRegistrationOnboardingGuard
                            allowIf={({ data }) =>
                                data?.businessType==="1"
                            }
                            redirectTo="/admin/register-seller-type"
                        >
                            <SellerRegistrationDocVerify />
                        </AdminRegistrationOnboardingGuard>
                    } 
                /> */}

                <Route
                    path="/admin/document-verification-company"
                    element={
                        <AdminRegistrationOnboardingGuard
                            allowIf={({ data }) => data?.businessType === BusinessType.Company}
                            redirectTo="/admin/register-seller-type"
                        >
                            <SellerRegistrationDocVerify />
                        </AdminRegistrationOnboardingGuard>
                    }
                />

                <Route
                    exact
                    path="/admin/shop-information-company"
                    element={
                        <AdminRegistrationOnboardingGuard
                            allowIf={
                                ({ data }) =>
                                    data?.businessType === BusinessType.Company &&
                                    !!data?.businessName &&
                                    !!data?.yearEstablished &&
                                    !!data?.businessRegistrationNumber &&
                                    !!data?.businessCertificate &&
                                    !!data?.sellerId &&
                                    !!data?.catalogue &&
                                    !!data?.name &&
                                    !!data?.email &&
                                    !!data?.phone &&
                                    !!data?.address
                                // !!data?.latitude &&
                                // !!data?.longitude
                            }
                            redirectTo="/admin/document-verification-company"
                        >
                            <SellerShopInformation />
                        </AdminRegistrationOnboardingGuard>
                    }
                    // element={<SellerShopInformation />}
                />

                <Route
                    exact
                    path="/admin/seller-subscription-payment-company"
                    element={
                        <AdminRegistrationOnboardingGuard
                            allowIf={({ data }) => {
                                if (data?.businessType === BusinessType.PersonalSeller) {
                                    // PERSONAL
                                    return (
                                        !!data?.name &&
                                        !!data?.birthdate &&
                                        (data?.gender === GenderEnum.Male || !!data?.gender) &&
                                        !!data?.nationality &&
                                        (data?.idType === IDTypeEnum.NationalID || !!data?.idType) &&
                                        !!data?.idNumber &&
                                        !!data?.idImage &&
                                        !!data?.productDescription &&
                                        (data?.numberProduct === 0 || !!data?.numberProduct) &&
                                        (data?.minPriceRange === 0 || !!data?.minPriceRange) &&
                                        (data?.maxPriceRange === 0 || !!data?.maxPriceRange)
                                    );
                                }

                                if (data?.businessType === BusinessType.Company) {
                                    // COMPANY
                                    return (
                                        !!data?.businessName &&
                                        !!data?.yearEstablished &&
                                        !!data?.businessRegistrationNumber &&
                                        !!data?.businessCertificate &&
                                        !!data?.sellerId &&
                                        !!data?.catalogue &&
                                        !!data?.name &&
                                        !!data?.email &&
                                        !!data?.phone &&
                                        !!data?.address &&
                                        // !!data?.latitude &&
                                        // !!data?.longitude &&
                                        !!data?.productDescription &&
                                        !!data?.numberProduct &&
                                        (data?.minPriceRange === 0 || !!data?.minPriceRange) &&
                                        // !!data?.shipping &&
                                        !!data?.shippingAddress &&
                                        // !!data?.shippinglatitude &&
                                        // !!data?.shippinglongitude &&
                                        (data?.maxPriceRange === 0 || !!data?.maxPriceRange)
                                    );
                                }
                            }}
                            redirectTo="/admin/shop-information-company"
                        >
                            <SellerSubsPaymentSummaryPage />
                        </AdminRegistrationOnboardingGuard>
                    }
                    // element={<SellerSubsPaymentSummaryPage />}
                />

                <Route
                    exact
                    path="/admin/document-verification-personal"
                    element={
                        <AdminRegistrationOnboardingGuard
                            allowIf={({ data }) => data?.businessType === BusinessType.PersonalSeller}
                            redirectTo="/admin/register-seller-type"
                        >
                            <PersonalSellerRegistrationDocVerify />
                        </AdminRegistrationOnboardingGuard>
                    }
                    // element={<PersonalSellerRegistrationDocVerify />}
                />

                <Route
                    exact
                    path="/admin/shop-information-personal"
                    element={
                        <AdminRegistrationOnboardingGuard
                            allowIf={({ data }) => {
                                console.log('DATA CHECK:', data);
                                return (
                                    data?.businessType === BusinessType.PersonalSeller &&
                                    !!data?.name &&
                                    !!data?.birthdate &&
                                    (data?.gender === GenderEnum.Male || !!data?.gender) &&
                                    !!data?.nationality &&
                                    (data?.idType === IDTypeEnum.NationalID || !!data?.idType) &&
                                    !!data?.idNumber &&
                                    !!data?.idImage
                                );
                            }}
                            redirectTo="/admin/register-seller-type"
                        >
                            <PersonalSellerShopInformation />
                        </AdminRegistrationOnboardingGuard>
                    }
                    // element={<PersonalSellerShopInformation />}
                />

                <Route
                    exact
                    path="/admin/seller-subscription-completed"
                    element={
                        <AdminRegistrationOnboardingGuard
                            allowIf={({ qris }) => !!qris?.qrisImage}
                            redirectTo="/admin/register-seller-type"
                        >
                            <AdminSellerRegisCompletedPage />
                        </AdminRegistrationOnboardingGuard>
                    }
                    // element={<AdminSellerRegisCompletedPage />}
                />
            </Route>

            <Route exact path="/term-and-condition" element={<TermsAndCondition />} />
            <Route exact path="/payment-policy" element={<PrivacyPolicy />} />
            <Route exact path="/membership-agreement" element={<MembershipAgreement />} />

        </Routes>
    </>
);

export default AppRouter;
